import { useState, useEffect, useCallback } from 'react';
import { Interview } from '@recruitai/shared';
import { apiClient } from '../lib/api-client';

export function useInterviews(jobId: string, candidateId: string) {
  const [interviews, setInterviews] = useState<Interview[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchInterviews = useCallback(async () => {
    if (!jobId || !candidateId) return;
    try {
      setIsLoading(true);
      const response = await apiClient.get<{ interviews: Interview[] }>(
        `/jobs/${jobId}/candidates/${candidateId}/interviews`
      );
      setInterviews(response.interviews);
    } catch {
      // Silencioso
    } finally {
      setIsLoading(false);
    }
  }, [jobId, candidateId]);

  useEffect(() => {
    fetchInterviews();
  }, [fetchInterviews]);

  return { interviews, isLoading, refetch: fetchInterviews };
}
